import { ChangeDetectionStrategy, Component, computed, inject, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { HmiLookupService } from '../../../../services/hmi-lookup.service';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';

@Component({
  selector: 'vardiya-devir-edit',
  standalone: true,
  imports: [FormsModule, NzInputModule, NzInputNumberModule, NzSelectModule,
    CdkTextareaAutosize],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="vd-edit">
      <div class="vd-baslik">
        <div class="vd-baslik-ikon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/>
            <path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"/>
          </svg>
        </div>
        <span>Vardiya Devir Teslim</span>
      </div>

      <div class="vd-form">
        <div class="form-grup">
          <label>Vardiya</label>
          <div class="input-wrap">
            <nz-select
              [ngModel]="p()?.vardiya"
              (ngModelChange)="guncelle('vardiya', $event)"
              nzPlaceHolder="Vardiya seçin..."
              style="width:100%"
              [nzCustomTemplate]="vardiyaTpl">
              <nz-option nzValue="sabah" nzLabel="Sabah (06:00 - 14:00)" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#f59e0b"></span><div class="sel-bilgi"><span class="sel-ad">Sabah</span><span class="sel-detay">06:00 - 14:00</span></div></div>
              </nz-option>
              <nz-option nzValue="ogle" nzLabel="Öğle (14:00 - 22:00)" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#3b82f6"></span><div class="sel-bilgi"><span class="sel-ad">Öğle</span><span class="sel-detay">14:00 - 22:00</span></div></div>
              </nz-option>
              <nz-option nzValue="gece" nzLabel="Gece (22:00 - 06:00)" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#6366f1"></span><div class="sel-bilgi"><span class="sel-ad">Gece</span><span class="sel-detay">22:00 - 06:00</span></div></div>
              </nz-option>
            </nz-select>
            <ng-template #vardiyaTpl let-selected>
              <span class="sel-item"><span class="sel-dot" [style.background]="vardiyaRenk(selected?.nzValue)"></span><span class="sel-ad">{{ selected?.nzLabel }}</span></span>
            </ng-template>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="form-grup">
          <label>Devreden</label>
          <div class="input-wrap">
            <nz-select
              [ngModel]="p()?.devreden"
              (ngModelChange)="guncelle('devreden', $event)"
              nzPlaceHolder="Devreden kişi..."
              nzAllowClear nzShowSearch
              style="width:100%"
              [nzCustomTemplate]="devredenTpl">
              @for (kisi of lookup.personeller(); track kisi._id) {
                <nz-option [nzValue]="kisi.ad + ' ' + kisi.soyad" [nzLabel]="kisi.ad + ' ' + kisi.soyad" nzCustomContent>
                  <div class="sel-item"><span class="sel-emoji">👤</span><div class="sel-bilgi"><span class="sel-ad">{{ kisi.ad }} {{ kisi.soyad }}</span><span class="sel-detay">{{ kisi.unvan || kisi.gorev || '' }}{{ kisi.sicilNo ? ' · ' + kisi.sicilNo : '' }}</span></div></div>
                </nz-option>
              }
            </nz-select>
            <ng-template #devredenTpl let-selected>
              <span class="sel-item"><span class="sel-emoji">👤</span><span class="sel-ad">{{ selected.nzLabel }}</span></span>
            </ng-template>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="form-grup">
          <label>Devralan</label>
          <div class="input-wrap">
            <nz-select
              [ngModel]="p()?.devralan"
              (ngModelChange)="guncelle('devralan', $event)"
              nzPlaceHolder="Devralan kişi..."
              nzAllowClear nzShowSearch
              style="width:100%"
              [nzCustomTemplate]="devralanTpl">
              @for (kisi of lookup.personeller(); track kisi._id) {
                <nz-option [nzValue]="kisi.ad + ' ' + kisi.soyad" [nzLabel]="kisi.ad + ' ' + kisi.soyad" nzCustomContent>
                  <div class="sel-item"><span class="sel-emoji">👤</span><div class="sel-bilgi"><span class="sel-ad">{{ kisi.ad }} {{ kisi.soyad }}</span><span class="sel-detay">{{ kisi.unvan || kisi.gorev || '' }}{{ kisi.sicilNo ? ' · ' + kisi.sicilNo : '' }}</span></div></div>
                </nz-option>
              }
            </nz-select>
            <ng-template #devralanTpl let-selected>
              <span class="sel-item"><span class="sel-emoji">👤</span><span class="sel-ad">{{ selected.nzLabel }}</span></span>
            </ng-template>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="vd-ayirici"></div>

        <div class="form-grup">
          <label>Makine Durumu</label>
          <div class="input-wrap">
            <nz-select
              [ngModel]="p()?.makineDurumu"
              (ngModelChange)="guncelle('makineDurumu', $event)"
              nzPlaceHolder="Makine durumu..."
              style="width:100%"
              [nzCustomTemplate]="mkDurumTpl">
              <nz-option nzValue="calisiyor" nzLabel="Çalışıyor" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#22c55e"></span><span class="sel-ad">Çalışıyor</span></div>
              </nz-option>
              <nz-option nzValue="arizali" nzLabel="Arızalı" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#ef4444"></span><span class="sel-ad">Arızalı</span></div>
              </nz-option>
              <nz-option nzValue="bakimda" nzLabel="Bakımda" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#f59e0b"></span><span class="sel-ad">Bakımda</span></div>
              </nz-option>
              <nz-option nzValue="bosta" nzLabel="Boşta" nzCustomContent>
                <div class="sel-item"><span class="sel-dot" style="background:#6b7280"></span><span class="sel-ad">Boşta</span></div>
              </nz-option>
            </nz-select>
            <ng-template #mkDurumTpl let-selected>
              <span class="sel-item"><span class="sel-dot" [style.background]="mkDurumRenk(selected?.nzValue)"></span><span class="sel-ad">{{ selected?.nzLabel }}</span></span>
            </ng-template>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="vd-ayirici"></div>

        <div class="form-grup">
          <label>Üretim Adedi</label>
          <div class="input-wrap">
            <nz-input-number
              [ngModel]="p()?.uretimAdedi || null"
              (ngModelChange)="guncelle('uretimAdedi', $event)"
              [nzMin]="0" [nzStep]="1"
              nzPlaceHolder="Üretim adedi"
              style="width:100%">
            </nz-input-number>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="form-grup">
          <label>Fire Adedi</label>
          <div class="input-wrap">
            <nz-input-number
              [ngModel]="p()?.fireAdedi || null"
              (ngModelChange)="guncelle('fireAdedi', $event)"
              [nzMin]="0" [nzStep]="1"
              nzPlaceHolder="Fire adedi"
              style="width:100%">
            </nz-input-number>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="vd-ayirici"></div>

        <div class="form-grup">
          <label>Bekleyen İşler</label>
          <div class="input-wrap">
            <textarea nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')"
              [ngModel]="p()?.bekleyenIsler || ''"
              (ngModelChange)="guncelle('bekleyenIsler', $event)"
              placeholder="Bekleyen işleri yazın..."
              cdkTextareaAutosize [cdkAutosizeMinRows]="2" [cdkAutosizeMaxRows]="4">
            </textarea>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="form-grup">
          <label>Önemli Notlar</label>
          <div class="input-wrap">
            <textarea nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')"
              [ngModel]="p()?.notlar || ''"
              (ngModelChange)="guncelle('notlar', $event)"
              placeholder="Önemli notları yazın..."
              cdkTextareaAutosize [cdkAutosizeMinRows]="2" [cdkAutosizeMaxRows]="4">
            </textarea>
            <div class="input-glow"></div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`

    :host { display: block; }

    .vd-edit { display: flex; flex-direction: column; gap: 0; padding: 0; }

    .vd-baslik {
      display: flex; align-items: center; gap: 10px;
      padding: 12px 16px; margin-bottom: 4px; border-radius: 10px;
      background: linear-gradient(135deg, var(--py-arkaplan-soluk, rgba(0,0,0,0.03)), transparent);
    }

    .vd-baslik-ikon {
      width: 32px; height: 32px; border-radius: 8px;
      display: flex; align-items: center; justify-content: center;
      background: linear-gradient(135deg, #0d9488, #14b8a6);
      color: #fff; flex-shrink: 0;
      box-shadow: 0 2px 8px rgba(13, 148, 136, 0.35);
      position: relative;
    }

    .vd-baslik-ikon::after {
      content: ''; position: absolute; inset: 0; border-radius: inherit;
      background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.2) 50%, transparent 100%);
      background-size: 200% 100%; animation: shimmer 3s infinite linear; pointer-events: none;
    }

    .vd-baslik span { font-size: 13px; font-weight: 600; color: var(--py-metin, #333); letter-spacing: 0.3px; }

    .vd-form { display: flex; flex-direction: column; gap: 14px; padding: 4px 2px; }

    .vd-ayirici {
      height: 1px; opacity: 0.4; margin: 2px 0;
      background: linear-gradient(90deg, transparent, var(--py-kenarlik, #d9d9d9) 20%, var(--py-kenarlik, #d9d9d9) 80%, transparent);
    }

    .form-grup { display: flex; flex-direction: column; gap: 5px; }

    .form-grup label {
      font-size: 11px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.6px; padding-left: 2px;
      color: var(--py-metin-ucuncul, rgba(0,0,0,0.45)); transition: color 0.2s ease;
    }

    .form-grup:focus-within label { color: var(--py-link, #1890ff); }

    .input-wrap { position: relative; }

    .input-glow {
      position: absolute; bottom: 0; left: 50%; width: 0; height: 2px; border-radius: 1px;
      background: linear-gradient(90deg, #0d9488, #14b8a6, #0d9488);
      transition: width 0.35s cubic-bezier(0.4, 0, 0.2, 1), left 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease;
      opacity: 0; pointer-events: none; z-index: 1;
    }

    .input-wrap:focus-within .input-glow { width: 100%; left: 0; opacity: 1; }

    .input-wrap input[nz-input],
    .input-wrap textarea[nz-input] {
      background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02));
      border: 1px solid var(--py-kenarlik, #d9d9d9); border-radius: 8px;
      padding: 7px 11px; font-size: 13px; color: var(--py-metin, #333);
      transition: border-color 0.25s ease, background 0.25s ease, box-shadow 0.25s ease;
    }

    .input-wrap input[nz-input]:hover,
    .input-wrap textarea[nz-input]:hover { border-color: var(--py-kenarlik-hover, #b3b3b3); background: var(--py-arkaplan-hover, #f5f5f5); }

    .input-wrap input[nz-input]:focus,
    .input-wrap textarea[nz-input]:focus { border-color: var(--py-kenarlik-aktif, #1890ff); background: var(--py-input-arka, #fff); box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1); outline: none; }

    .input-wrap ::ng-deep .ant-select-selector {
      background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02)) !important;
      border: 1px solid var(--py-kenarlik, #d9d9d9) !important; border-radius: 8px !important; min-height: 34px;
      transition: border-color 0.25s ease, background 0.25s ease, box-shadow 0.25s ease;
    }

    .input-wrap:hover ::ng-deep .ant-select-selector { border-color: var(--py-kenarlik-hover, #b3b3b3) !important; background: var(--py-arkaplan-hover, #f5f5f5) !important; }
    .input-wrap:focus-within ::ng-deep .ant-select-selector { border-color: var(--py-kenarlik-aktif, #1890ff) !important; background: var(--py-input-arka, #fff) !important; box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1) !important; }

    .input-wrap ::ng-deep .ant-input-number {
      background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02)) !important;
      border: 1px solid var(--py-kenarlik, #d9d9d9) !important; border-radius: 8px !important;
      transition: border-color 0.25s ease, background 0.25s ease, box-shadow 0.25s ease;
    }

    .input-wrap:hover ::ng-deep .ant-input-number { border-color: var(--py-kenarlik-hover, #b3b3b3) !important; }
    .input-wrap:focus-within ::ng-deep .ant-input-number { border-color: var(--py-kenarlik-aktif, #1890ff) !important; box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1) !important; }

    @keyframes shimmer { 0% { background-position: -200% center; } 100% { background-position: 200% center; } }
  `],
})
export class VardiyaDevirEditComponent extends FikoYTKokBilesenComponent {
  parametreler = model<any>();
  lookup = inject(HmiLookupService);

  constructor() { super(); this.lookup.personelleriYukle(); }

  p = computed(() => this.parametreler()?.ek || {});

  vardiyaRenk(v: string): string {
    const m: Record<string, string> = { 'sabah': '#f59e0b', 'ogle': '#3b82f6', 'gece': '#6366f1' };
    return m[v] || '#6b7280';
  }

  mkDurumRenk(v: string): string {
    const m: Record<string, string> = { 'calisiyor': '#22c55e', 'arizali': '#ef4444', 'bakimda': '#f59e0b', 'bosta': '#6b7280' };
    return m[v] || '#6b7280';
  }

  guncelle(alan: string, deger: any) {
    const params = this.parametreler();
    if (params?.ek) {
      params.ek[alan] = deger;
      this.parametreler.set({ ...params });
    }
  }
}
